import React from "react";
import PropTypes from "prop-types";
import { CardConnector } from "../../../connectors/CardConnector";
import { Cell, Row } from "../../Grid";

function calculateColsValue(cardsLength) {
	if (cardsLength <= 2) {
		return 1;
	}
	if (cardsLength === 3) {
		return 3;
	}
	return 4;
}

const ThingsToDoCards = ({ cards }) => {
	const colsValue = calculateColsValue(cards.length);
	return (
		!!cards && (
			<Row cols={colsValue}>
				{cards.map(tile => {
					const remappedTile = {
						heading: tile.title,
						headingAs: "h3",
						variant: "Primary Default",
						link: {
							variant: tile.link.variant,
							linkText: tile.link.text,
							url: tile.link.to,
							target: "EXTERNAL_MODAL",
							externalModalMessage: tile.modalMessage,
						},
						theme: "Dark",
						image: tile.image,
					};
					return (
						<Cell key={tile.id}>
							<CardConnector data={remappedTile} />
						</Cell>
					);
				})}
			</Row>
		)
	);
};

ThingsToDoCards.propTypes = {
	cards: PropTypes.arrayOf(PropTypes.object),
};
ThingsToDoCards.defaultProps = {
	cards: [],
};

export { ThingsToDoCards };
